import React from 'react';
import { Zap } from 'lucide-react';

export const AppIcon = ({ size = 80, className = "" }) => {
  return (
    <div 
      className={`relative rounded-2xl bg-gradient-to-br from-[#8FEC78] to-[#5BC943] flex items-center justify-center shadow-xl ${className}`}
      style={{ width: size, height: size }}
    >
      {/* Lightning bolt */}
      <Zap 
        size={size * 0.5} 
        className="text-white drop-shadow-lg" 
        strokeWidth={2.5}
        fill="white"
      />
      
      {/* Decorative circles */}
      <div 
        className="absolute rounded-full bg-white/30"
        style={{ 
          width: size * 0.12, 
          height: size * 0.12, 
          top: size * 0.15, 
          right: size * 0.15 
        }}
      />
      <div 
        className="absolute rounded-full bg-white/25"
        style={{ 
          width: size * 0.08, 
          height: size * 0.08, 
          bottom: size * 0.18, 
          left: size * 0.15 
        }}
      />
    </div>
  );
};

export default AppIcon;
